import React, { FC, useMemo } from 'react';

import { DropDownOptions } from 'devextreme-react/select-box';
import { RequiredRule } from 'devextreme-react/validator';

import AppFiledBox from 'components/appComponents/app-field-box';
import { SelectBox, Validator } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';

type Props = {
  value: number | null;
  readOnly: boolean;
  onChange: (value: any) => void;
};

const Factory: FC<Props> = ({ onChange, readOnly, value }) => {
  const factoryDataStore: DataSource = useMemo(() => {
    const defaultFilter = ['parentId', '=', null];
    return $createDataSource('/v1/factory', 'id', { pageSize: 20, paginate: true, defaultFilter });
  }, []);

  return (
    <AppFiledBox label="Площадка *" labelTop>
      <SelectBox
        stylingMode="underlined"
        dataSource={factoryDataStore}
        displayExpr="name"
        valueExpr="id"
        value={value}
        onItemClick={(e) => {
          onChange(e.itemData.id);
        }}
        readOnly={readOnly}
      >
        <DropDownOptions title="Выберите Площадку" closeOnOutsideClick={true} showTitle={false} />
        <Validator>
          <RequiredRule message="Выберите Площадку" />
        </Validator>
      </SelectBox>
    </AppFiledBox>
  );
};

export default Factory;
